import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "operators" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "first-column-with-icon-type" }
const _hoisted_6 = { class: "name-type-block" }
const _hoisted_7 = { class: "type-data-mini" }
const _hoisted_8 = { class: "name-data" }
const _hoisted_9 = { class: "first-column-with-icon-type" }
const _hoisted_10 = { class: "name-type-block" }
const _hoisted_11 = { class: "type-data-mini" }
const _hoisted_12 = { class: "name-data" }
const _hoisted_13 = { class: "emq-table-footer" }

import { getOperatorList, banOperator, switchOperatorOperation } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import { dateFormat, throttleBtn } from '@/common/tools'
import PreWithEllipsis from '@/components/PreWithEllipsis.vue'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import OperatorUpsert, { OperationType } from './components/OperatorUpsert.vue'
import { Ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { checkMenuShow } from '@/store/tool'
import { FieldEnable } from '@/types/types'

import { defineComponent, ref } from 'vue'

const __default__ = defineComponent({
  name: 'Operators',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Evses')

const showDialog = ref(false)
const showMoreQuery = ref(false)
const showOperatorType: Ref<OperationType> = ref('create')
const showOperator: Ref<undefined | Record<string, any>> = ref(undefined)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { enableSelects, getCountry, getCurrency, getCurrencySymbol } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('operators-detail')

const addOperator = () => {
  showDialog.value = true
  showOperator.value = undefined
  showOperatorType.value = 'create'
}

const editOperator = (operator: any) => {
  showDialog.value = true
  showOperator.value = operator
  showOperatorType.value = 'edit'
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  console.log('params', params.value)
  loadTableData({ page: 1 })
}

const handleSwitchOperation = async (row: any) => {
  var selfOperating = FieldEnable.CES_DISABLE
  if (row.isSelfOperating) {
    selfOperating = FieldEnable.CES_ENABLE

    await ElMessageBox.confirm(t('Operation.disableOperatorOperationWarn'), {
      confirmButtonText: t('Base.confirm'),
      cancelButtonText: t('Base.cancel'),
      confirmButtonClass: 'confirm-danger',
      type: 'warning',
    })
      .then(async (res) => {
        await switchOperatorOperation(row.id, selfOperating)
        ElMessage.success(t('Base.opSuccess'))
        loadTableData()
      })
      .finally(() => {
        loadTableData()
      })
  } else {
    await switchOperatorOperation(row.id, selfOperating)
    ElMessage.success(t('Base.opSuccess'))
  }
}

const handleSwitchStatus = async (row: any) => {
  try {
    await banOperator(row.id, row.banned)
    if (row.banned) {
      ElMessage.success(t('Base.disabledSuccess'))
    } else {
      ElMessage.success(t('Base.enableSuccess'))
    }

    loadTableData()
    return Promise.resolve()
  } catch (error) {
    console.error(error)
    return Promise.reject()
  }
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, sn, enable, firewareVersion, state, beginTime, endTime, operatorName } = params
  newParams = {
    id: id || undefined,
    sn: sn || undefined,
    enable: enable || undefined,
    firewareVersion: firewareVersion || undefined,
    state: state || undefined,
    beginTime: beginTime || undefined,
    endTime: endTime || undefined,
    operatorName: operatorName || undefined,
  }
  return newParams
}

const loadTableData = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
  }

  try {
    const { list = [], pageReply = {} } = await getOperatorList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadTableData)

loadTableData()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.id) = $event)),
                  placeholder: _ctx.$t('Base.id'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.operatorName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.operatorName) = $event)),
                  placeholder: _ctx.$t('Base.name'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: fuzzyParams.value.enable,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.enable) = $event)),
                  placeholder: _ctx.$t('Base.isEnabled'),
                  clearable: "",
                  onClear: handleSearch
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(enableSelects), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: item.value,
                        key: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Search),
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(RefreshLeft),
                  onClick: handleReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (addOperator()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'operatorAdd']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            "min-width": "80",
            label: _ctx.$t('Base.name'),
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              (_unref(checkMenuShow)('operatorInfo'))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {
                name: 'operator-detail',
                params: { id: row.id },
              }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        content: row.id,
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(PreWithEllipsis, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 1,
                    content: row.id,
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(PreWithEllipsis, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["content"]))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "company",
            "min-width": "120",
            label: _ctx.$t('Operation.company')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "country",
            "min-width": "80",
            label: _ctx.$t('Operation.country')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(_unref(getCountry)(Number(row.country))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "currency",
            "min-width": "80",
            label: _ctx.$t('Operation.currency')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(row.currency ? _unref(getCurrencySymbol)(Number(row.currency)) : '-'), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(row.currency ? _unref(getCurrency)(Number(row.currency)) : '-'), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operatorPrincipal",
            "min-width": "80",
            label: _ctx.$t('Operation.contacts')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "principalPhone",
            "min-width": "120",
            label: _ctx.$t('Operation.contactmt')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(row.principalPhone ? row.principalPhone : '-'), 1),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(row.principalEmail), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "banned",
            label: _ctx.$t('Base.isEnabled')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_switch, {
                modelValue: row.banned,
                "onUpdate:modelValue": ($event: any) => ((row.banned) = $event),
                "active-value": false,
                "inactive-value": true,
                onChange: ($event: any) => (handleSwitchStatus(row)),
                disabled: !_unref(checkMenuShow)('operatorUpsert')
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "isSelfOperating",
            label: _ctx.$t('Operation.agencyOperation')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_switch, {
                modelValue: row.isSelfOperating,
                "onUpdate:modelValue": ($event: any) => ((row.isSelfOperating) = $event),
                "active-value": false,
                "inactive-value": true,
                onChange: ($event: any) => (handleSwitchOperation(row)),
                disabled: !_unref(checkMenuShow)('operatorBan')
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "createdAt",
            "min-width": "100",
            label: _ctx.$t('Base.createdAt')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (editOperator(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'operatorUpsert']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[4] || (_cache[4] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTableData
        }, null, 8, ["metaData"])
      ]),
      _createVNode(OperatorUpsert, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showDialog).value = $event)),
        operationType: showOperatorType.value,
        operatorInfo: showOperator.value,
        onSubmitted: loadTableData
      }, null, 8, ["modelValue", "operationType", "operatorInfo"])
    ])
  ]))
}
}

})